import { useState } from 'react';
import { Container, Row, Col, Card, Form, Button, Alert } from 'react-bootstrap';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });
  const [submitted, setSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // In a real app, this would send the form data to an API
    setSubmitted(true);
  };

  const contactMethods = [
    {
      icon: 'bi-envelope',
      title: 'Email Us',
      description: 'General inquiries',
      contact: 'hello@paperdate.io',
      href: 'mailto:hello@paperdate.io'
    },
    {
      icon: 'bi-headset',
      title: 'Support',
      description: 'Technical help',
      contact: 'support@paperdate.io',
      href: 'mailto:support@paperdate.io'
    },
    {
      icon: 'bi-shield',
      title: 'Safety',
      description: 'Report concerns',
      contact: 'safety@paperdate.io',
      href: 'mailto:safety@paperdate.io'
    }
  ];

  return (
    <Container className="py-5">
      <Row className="justify-content-center mb-5">
        <Col lg={8} className="text-center">
          <h1 className="display-4 fw-bold mb-4">Contact Us</h1>
          <p className="lead text-muted">
            Have a question or feedback? We'd love to hear from you. Reach out and we'll respond as soon as possible.
          </p>
        </Col>
      </Row>

      <Row className="mb-5">
        {contactMethods.map((method, index) => (
          <Col md={4} key={index} className="mb-4 mb-md-0">
            <Card className="border-0 shadow-sm h-100 text-center">
              <Card.Body className="p-4">
                <i className={`bi ${method.icon} display-4 text-primary mb-3`}></i>
                <h5 className="fw-bold">{method.title}</h5>
                <p className="text-muted mb-2">{method.description}</p>
                <a href={method.href} className="text-primary fw-bold">{method.contact}</a>
              </Card.Body>
            </Card>
          </Col>
        ))}
      </Row>

      <Row className="justify-content-center">
        <Col lg={8}>
          <Card className="border-0 shadow-sm">
            <Card.Body className="p-4 p-lg-5">
              <h3 className="fw-bold mb-4 text-center">Send Us a Message</h3>
              
              {submitted ? (
                <Alert variant="success" className="text-center">
                  <i className="bi bi-check-circle-fill me-2"></i>
                  Thank you for your message! We'll get back to you within 24-48 hours.
                </Alert>
              ) : (
                <Form onSubmit={handleSubmit}>
                  <Row>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Your Name</Form.Label>
                        <Form.Control
                          type="text"
                          name="name"
                          value={formData.name}
                          onChange={handleChange}
                          placeholder="John Doe"
                          required
                        />
                      </Form.Group>
                    </Col>
                    <Col md={6}>
                      <Form.Group className="mb-3">
                        <Form.Label>Email Address</Form.Label>
                        <Form.Control
                          type="email"
                          name="email"
                          value={formData.email}
                          onChange={handleChange}
                          placeholder="john@example.com"
                          required
                        />
                      </Form.Group>
                    </Col>
                  </Row>
                  <Form.Group className="mb-3">
                    <Form.Label>Subject</Form.Label>
                    <Form.Select
                      name="subject"
                      value={formData.subject}
                      onChange={handleChange}
                      required
                    >
                      <option value="">Select a topic</option>
                      <option value="general">General Inquiry</option>
                      <option value="support">Technical Support</option>
                      <option value="billing">Billing Question</option>
                      <option value="feedback">Feedback</option>
                      <option value="partnership">Partnership</option>
                      <option value="other">Other</option>
                    </Form.Select>
                  </Form.Group>
                  <Form.Group className="mb-4">
                    <Form.Label>Message</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={5}
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      placeholder="How can we help you?"
                      required
                    />
                  </Form.Group>
                  <div className="text-center">
                    <Button variant="primary" type="submit" size="lg">
                      Send Message
                    </Button>
                  </div>
                </Form>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default Contact;

